/* Live co-editing and client participant screens (Phase 2). Not in the reference tool, so these
   follow its colours, radii and type scale. */

/* ---------- presence ---------- */
.presence {
  display: inline-flex;
  align-items: center;
}
.avatars {
  display: inline-flex;
  list-style: none;
  margin: 0;
  padding: 0 0 0 6px;
}
.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: #fff;
  font-size: 11.5px;
  font-weight: 900;
  letter-spacing: 0.02em;
  margin-left: -6px;
  border: 2px solid var(--surface);
  cursor: default;
}
.avatar.leading {
  box-shadow: 0 0 0 2px var(--green-l);
}
.more {
  background: var(--bg);
  color: var(--ink);
  border-color: var(--border-strong);
}

/* ---------- workshop bar ---------- */
.workshop {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 9px 26px;
  background: #eef7f0;
  border-bottom: 1px solid var(--border);
  font-size: 14px;
  color: var(--ink);
}
.workshop strong {
  font-weight: 900;
}
.workshop .spacer {
  flex: 1 1 auto;
}
.linkBtn {
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-weight: 700;
  color: var(--blue-d);
  text-decoration: underline;
  cursor: pointer;
}
.linkBtn:hover {
  color: var(--blue-text);
}
.toggle[aria-pressed="true"] {
  background: var(--green-d);
  border-color: var(--green-d);
  color: #fff;
}

/* ---------- Share panel ---------- */
.share {
  max-width: 620px;
}
.people {
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 10px;
  max-height: 280px;
  overflow: auto;
}
.person {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-top: 1px solid var(--border);
  font-size: 14px;
}
.person:first-child {
  border-top: none;
}
.personText {
  flex: 1 1 auto;
  min-width: 0;
}
.personName {
  font-weight: 700;
  color: var(--ink);
}
.personEmail {
  display: block;
  color: var(--muted);
  font-size: 12.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tag {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--bg);
  color: var(--ink);
  white-space: nowrap;
}
.tag.revoked {
  background: var(--amber-bg);
}
.smallBtn {
  border: 1px solid var(--border-strong);
  background: var(--surface);
  color: var(--blue-d);
  font-weight: 700;
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 8px;
}
.smallBtn:hover {
  border-color: var(--blue-l);
  color: var(--blue-text);
}
.primaryBtn {
  background: var(--blue-d);
  border-color: var(--blue-d);
  color: #fff;
  font-size: 14px;
  padding: 9px 18px;
}
.primaryBtn:hover {
  background: var(--blue-l);
  border-color: var(--blue-l);
  color: #fff;
}
.primaryBtn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.inviteGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}
.inviteGrid label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
  margin-bottom: 4px;
}
.wide {
  grid-column: 1 / -1;
}
.hint {
  font-size: 12.5px;
  color: var(--muted);
  margin: 10px 0 0;
}
.hint a {
  color: var(--blue-d);
  font-weight: 700;
}
.hint a:hover {
  color: var(--blue-text);
}
.error {
  color: var(--ink);
  background: var(--amber-bg);
  border-left: 3px solid var(--amber-line);
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 700;
  margin: 8px 0 0;
}

/* ---------- guest sign-in and home ---------- */
.guestWrap {
  max-width: 760px;
  margin: 44px auto;
  padding: 0 24px;
}
.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 30px 32px;
}
.card h1 {
  font-size: 26px;
  color: var(--ink);
  margin: 4px 0 10px;
}
.eyebrow {
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--green-text);
}
.field {
  margin: 16px 0;
}
.field label {
  display: block;
  font-weight: 700;
  font-size: 14px;
  color: var(--ink);
  margin-bottom: 6px;
}
.field input {
  width: 100%;
  max-width: 380px;
  border: 1px solid var(--border-strong);
  border-radius: 9px;
  padding: 11px 13px;
  font-size: 16px;
}
.field input:focus {
  outline: none;
  border-color: var(--blue-l);
  box-shadow: 0 0 0 3px rgba(12, 134, 188, 0.35);
}
.code {
  letter-spacing: 0.3em;
  font-size: 22px !important;
  max-width: 220px !important;
}
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-top: 18px;
}
.note {
  color: var(--muted);
  font-size: 14px;
}
.mapList {
  list-style: none;
  padding: 0;
  margin: 18px 0 0;
}
.mapList li {
  border-top: 1px solid var(--border);
}
.mapList a {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 4px;
  color: var(--blue-d);
  font-weight: 700;
  text-decoration: none;
}
.mapList a:hover {
  color: var(--blue-text);
  text-decoration: underline;
}
.turnstile {
  margin: 12px 0;
  min-height: 65px;
}
